export default __webpack_public_path__ + "static/media/a20.0ee80478.webp";